import { useContext } from "react"

import PropTypes from "prop-types"

import ConfigurationContext from "../../../context/ConfigurationContext"

import styles from "./AreaListItem.module.scss"

const AreaListItem = ({ areaId, icon, name, active }) => {
  const context = useContext(ConfigurationContext)
  const { goToArea } = context

  const isViewer = false

  const handleSelectArea = () => {
    if (!active) {
      return null
    }

    goToArea(areaId)
  }

  return (
    <li
      className={[styles.listItem, !active ? styles.disabled : " "].join(" ")}
    >
      <button
        type="button"
        onClick={handleSelectArea}
        className={styles.buttonItem}
        disabled={isViewer}
      >
        {icon && <span className={styles.iconList}>{icon}</span>}
        {name && <h3 className={styles.h3}>{name}</h3>}

        <span className={styles.contentSvg}>
          <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M0.0309305 7.99963C0.0311069 7.74965 0.233902 7.54714 0.483886 7.54732L20.197 7.56123C20.447 7.56141 20.6495 7.7642 20.6493 8.01419C20.6492 8.26417 20.4464 8.46668 20.1964 8.4665L0.483247 8.45259C0.233263 8.45241 0.030754 8.24962 0.0309305 7.99963Z" fill="white"/>
          <path fillRule="evenodd" clipRule="evenodd" d="M13.3006 0.631511C13.4816 0.459077 13.7681 0.466016 13.9405 0.64701L20.9314 7.98498L13.9413 15.3523C13.7693 15.5337 13.4828 15.5412 13.3014 15.3691C13.1201 15.1971 13.1126 14.9106 13.2846 14.7292L19.6823 7.98627L13.2851 1.27145C13.1126 1.09045 13.1196 0.803945 13.3006 0.631511Z" fill="white"/>
          </svg>
        </span>
      </button>
    </li>
  )
}

export default AreaListItem

AreaListItem.propTypes = {
  areaId: PropTypes.string.isRequired,
  icon: PropTypes.node,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
}

AreaListItem.defaultProps = {
  areaId: "",
  icon: null,
  name: "",
  active: true,
}
